export default __webpack_public_path__ + "static/media/jeremy.3d197aa8.jpg";